import React from "react";
import { motion } from "framer-motion";
import { Landmark, UserRound, Compass, MessagesSquare, BellRing, Map } from "lucide-react";

const items = [
  { icon: Landmark, title: "High Court Experience", desc: "Regular appearances before the Bombay High Court and the Kolhapur Bench." },
  { icon: UserRound, title: "Individual Attention", desc: "Every matter is briefed, drafted and argued personally." },
  { icon: Compass, title: "Strategic Legal Advice", desc: "Honest counsel that weighs cost, remedy and probability of success." },
  { icon: MessagesSquare, title: "Transparent Communication", desc: "Clear updates in plain language without unnecessary jargon." },
  { icon: BellRing, title: "Prompt Case Updates", desc: "Timely intimation of listings, orders and next steps." },
  { icon: Map, title: "Across India", desc: "Representation before subordinate courts and tribunals nationwide." },
];

export default function WhyChoose() {
  return (
    <section className="py-24 md:py-40 bg-[#0B0B0B]" data-testid="why-choose-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-24">
        <div className="mb-16 md:mb-24 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-white/95">Why<br/><span className="italic text-[#C8A45D]/90">Nexus Legal.</span></h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-white/60 font-body text-base md:text-lg leading-relaxed self-end">
            A practice built on careful preparation, thoughtful advocacy, and unwavering consistency in representation, rather than the number of matters handled.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="p-8 md:p-12 border-r border-b border-white/5 group hover:bg-white/[0.02] transition-colors duration-500"
                data-testid={`why-item-${i}`}
              >
                <Icon className="text-[#C8A45D] mb-8" strokeWidth={1.2} size={30} />
                <div className="font-cinzel text-[10px] tracking-[0.3em] text-white/40 mb-3">0{i+1}</div>
                <h3 className="font-serif-display text-2xl md:text-3xl text-white/95 mb-4 leading-tight">{it.title}</h3>
                <p className="text-white/55 font-body text-sm leading-relaxed">{it.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
